let mockPostSeed = 0;

function createAlbumPhoto (title, subtitle, startColor, endColor, accentColor) {
    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="480" height="480" viewBox="0 0 480 480">
            <defs>
                <linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="${startColor}" />
                    <stop offset="100%" stop-color="${endColor}" />
                </linearGradient>
            </defs>
            <rect width="480" height="480" rx="36" fill="url(#bg)" />
            <circle cx="376" cy="96" r="74" fill="rgba(255,255,255,0.28)" />
            <circle cx="118" cy="368" r="92" fill="rgba(255,255,255,0.16)" />
            <rect x="148" y="98" width="182" height="212" rx="82" fill="${accentColor}" transform="rotate(-7 239 204)" />
            <circle cx="240" cy="176" r="34" fill="#fff6ee" />
            <rect x="184" y="218" width="112" height="92" rx="44" fill="#fff6ee" />
            <rect x="48" y="46" width="132" height="34" rx="17" fill="rgba(255,255,255,0.42)" />
            <text x="48" y="366" font-size="30" font-family="Arial, sans-serif" font-weight="700" fill="#ffffff">${title}</text>
            <text x="48" y="404" font-size="20" font-family="Arial, sans-serif" fill="rgba(255,255,255,0.88)">${subtitle}</text>
            <rect x="48" y="420" width="158" height="22" rx="11" fill="rgba(255,255,255,0.32)" />
        </svg>
    `;

    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

function createReactionState () {
    return {
        wow: 0,
        smile: 0,
        cute: 0,
        love: 0
    };
}

function decorateEntry (entry) {
    return {
        ...entry,
        images: entry.images ? [...entry.images] : [],
        selectedReaction: entry.selectedReaction || '',
        reactions: {
            ...createReactionState(),
            ...(entry.reactions || {})
        }
    };
}

function createPostId (prefix) {
    mockPostSeed += 1;
    return `${prefix}-${Date.now()}-${mockPostSeed}`;
}

const photoPool = [
    createAlbumPhoto('03/25', 'LIVING ROOM 01', '#f0ba7b', '#d76a55', '#fef4dd'),
    createAlbumPhoto('03/25', 'LIVING ROOM 02', '#f3d8a5', '#f08f6e', '#fff3e3'),
    createAlbumPhoto('03/25', 'LIVING ROOM 03', '#f5b6aa', '#ed8d73', '#fff2db'),
    createAlbumPhoto('03/25', 'LIVING ROOM 04', '#b3d8dd', '#7da1cb', '#fff7ea'),
    createAlbumPhoto('03/25', 'LIVING ROOM 05', '#a8cdb2', '#6d9f8f', '#fff7eb'),
    createAlbumPhoto('03/22', 'PARK MAT 01', '#f7d9a6', '#f6a15f', '#fff4e8'),
    createAlbumPhoto('03/22', 'PARK MAT 02', '#f2c8bc', '#ef9b8d', '#fff5ee'),
    createAlbumPhoto('03/12', 'BEDROOM 01', '#d9c4de', '#f3a7bc', '#fef6e9'),
    createAlbumPhoto('03/12', 'BEDROOM 02', '#b2c7ec', '#d4a0d6', '#fff8ed'),
    createAlbumPhoto('03/12', 'BEDROOM 03', '#f5d3b0', '#e8a0a6', '#fff5e8'),
    createAlbumPhoto('03/12', 'BEDROOM 04', '#d0d8f0', '#8db2df', '#fff7ec'),
    createAlbumPhoto('03/08', 'STROLLER 01', '#f2c4b2', '#d67f67', '#fff7ea'),
    createAlbumPhoto('03/08', 'STROLLER 02', '#f4dd9d', '#efb876', '#fff9ee'),
    createAlbumPhoto('03/08', 'SUNSET 01', '#d84d4a', '#7a2231', '#ffe6b5'),
    createAlbumPhoto('03/08', 'SUNSET 02', '#f3c655', '#dd7b3c', '#fff4db')
];

export const albumTodayGroup = {
    id: '2026-03-25',
    label: '今天',
    displayDate: '3月25日',
    ageText: '7个月5天'
};

export const albumSampleSets = [
    photoPool.slice(0, 3),
    photoPool.slice(1, 5),
    photoPool.slice(5, 7),
    photoPool.slice(7, 10)
];

export const babyProfile = {
    name: '宝宝',
    dateNumber: '25',
    weekText: '星期三',
    monthText: '03/2026',
    ageText: '7个月5天',
    heroTitle: '把成长切成会发光的片段',
    heroSubtitle: '照片、视频和精选片段，统一收进宝宝成长时间轴。'
};

export const babyToolList = [
    {
        key: 'camera',
        label: '拍摄',
        symbol: '拍',
        color: '#ff9552',
        description: '即时记录宝宝状态'
    }
];

export const creatorOptions = [
    {
        key: 'photo',
        label: '照片视频',
        symbol: '图',
        color: '#5ed39a',
        description: '从相册补选图片或视频'
    },
    {
        key: 'camera',
        label: '拍摄',
        symbol: '拍',
        color: '#ff9d66',
        description: '马上记录眼前这一刻'
    },
    {
        key: 'smart-upload',
        label: '智能上传',
        symbol: '智',
        color: '#6ca7ff',
        description: '筛出候选素材后批量导入'
    }
];

export const mediaFilterOptions = [
    {
        value: 'all',
        label: '全部'
    },
    {
        value: 'photo',
        label: '照片'
    },
    {
        value: 'video',
        label: '视频'
    }
];

export const albumDateOptions = [
    {
        value: 'all',
        label: '全部时间'
    },
    {
        value: albumTodayGroup.id,
        label: albumTodayGroup.displayDate
    },
    {
        value: '2026-03-22',
        label: '3月22日'
    },
    {
        value: '2026-03-12',
        label: '3月12日'
    },
    {
        value: '2026-03-08',
        label: '3月8日'
    }
];

export const uploadBanner = {
    title: '上传队列',
    message: '2 条内容正在同步到宝宝时间轴，请保持网络畅通。',
    progress: 43
};

const baseSmartUploadCandidates = [
    {
        id: 'candidate-1',
        title: '客厅练习抬头',
        takenAt: '今天 09:26',
        source: '系统相册',
        location: '客厅',
        type: 'photo',
        images: photoPool.slice(0, 2)
    },
    {
        id: 'candidate-2',
        title: '窗边晒太阳',
        takenAt: '今天 10:42',
        source: '收藏夹',
        location: '窗边',
        type: 'photo',
        images: photoPool.slice(2, 3)
    },
    {
        id: 'candidate-3',
        title: '奶后安静看书',
        takenAt: '昨天 15:18',
        source: '系统相册',
        location: '卧室',
        type: 'photo',
        images: photoPool.slice(7, 8)
    }
];

export const smartUploadCandidates = baseSmartUploadCandidates;

const sourceGroups = [
    {
        ...albumTodayGroup,
        entries: [
            {
                id: 'entry-0325-1',
                postType: 'photo',
                author: '妈妈',
                relativeTime: '3分钟前',
                caption: '第一次自己扶着坐稳，马上拍了几张留念',
                location: '客厅地垫',
                uploadStatus: 'pending',
                uploadText: '等待上传中',
                images: photoPool.slice(0, 4)
            },
            {
                id: 'entry-0325-2',
                postType: 'photo',
                author: '妈妈',
                relativeTime: '18分钟前',
                caption: '午睡醒来后精神很好，连续翻了三次身，还会主动抬头找人。',
                location: '客厅',
                uploadStatus: 'done',
                uploadText: '云端已备份',
                images: photoPool.slice(1, 4),
                selectedReaction: 'cute'
            },
            {
                id: 'entry-0325-3',
                postType: 'video',
                author: '妈妈',
                relativeTime: '31分钟前',
                caption: '醒来后在床边连续咿呀了好久，顺手录下这一段。',
                location: '婴儿床',
                uploadStatus: 'done',
                uploadText: '云端已备份',
                videoDuration: '00:28',
                images: photoPool.slice(4, 5),
                selectedReaction: 'smile'
            }
        ]
    },
    {
        id: '2026-03-22',
        label: '3月22日',
        displayDate: '3月22日',
        ageText: '7个月2天',
        entries: [
            {
                id: 'entry-0322-1',
                postType: 'video',
                author: '妈妈',
                relativeTime: '4分钟前',
                caption: '第一次和朋友一起趴趴晒太阳',
                location: '公园地垫',
                uploadStatus: 'pending',
                uploadText: '等待上传中',
                videoDuration: '00:12',
                images: photoPool.slice(5, 6)
            },
            {
                id: 'entry-0322-2',
                postType: 'photo',
                author: '妈妈',
                relativeTime: '26分钟前',
                caption: '阳光正好，给宝宝拍了两张近景',
                location: '草地边',
                uploadStatus: 'done',
                uploadText: '已同步到时间轴',
                images: photoPool.slice(5, 7),
                selectedReaction: 'love'
            }
        ]
    },
    {
        id: '2026-03-12',
        label: '3月12日',
        displayDate: '3月12日',
        ageText: '6个月27天',
        entries: [
            {
                id: 'entry-0312-1',
                postType: 'photo',
                author: '妈妈',
                relativeTime: '5分钟前',
                caption: '午睡醒来以后，宝宝连续做了好多小表情',
                location: '卧室',
                uploadStatus: 'done',
                uploadText: '云端已备份',
                images: photoPool.slice(7, 11)
            }
        ]
    },
    {
        id: '2026-03-08',
        label: '3月8日',
        displayDate: '3月8日',
        ageText: '6个月16天',
        entries: [
            {
                id: 'entry-0308-1',
                postType: 'photo',
                author: '爸爸',
                relativeTime: '12分钟前',
                caption: '第一次坐在推车里出门，整个人都很精神。',
                location: '小区门口',
                uploadStatus: 'done',
                uploadText: '云端已备份',
                images: photoPool.slice(11, 13)
            }
        ]
    }
];

export function createSmartUploadCandidates () {
    return baseSmartUploadCandidates.map(candidate => ({
        ...candidate,
        images: [...candidate.images],
        selected: false
    }));
}

export function createAlbumGroups () {
    return sourceGroups.map(group => ({
        ...group,
        entries: group.entries.map(decorateEntry)
    }));
}

export function createMockPost (postType, payload = {}) {
    const normalizedType = postType === 'camera' ? (payload.mediaType || 'photo') : postType;
    const baseEntry = {
        id: createPostId(normalizedType),
        postType: normalizedType,
        author: payload.author || '妈妈',
        relativeTime: payload.relativeTime || '刚刚',
        caption: payload.caption || '',
        location: payload.location || '宝宝相册',
        uploadStatus: payload.uploadStatus || 'pending',
        uploadText: payload.uploadText || '等待上传中'
    };

    if (normalizedType === 'video') {
        return decorateEntry({
            ...baseEntry,
            caption: payload.caption || '刚拍好一段短视频',
            images: payload.images || albumSampleSets[2],
            videoDuration: payload.videoDuration || '00:15'
        });
    }

    return decorateEntry({
        ...baseEntry,
        caption: payload.caption || '刚保存了一组新照片',
        images: payload.images || albumSampleSets[0]
    });
}
